import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UploadingReceipt = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="uploading receipt icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 43.5C15 42.6716 15.6716 42 16.5 42L29.5 42C30.3284 42 31 42.6716 31 43.5C31 44.3284 30.3284 45 29.5 45H16.5C15.6716 45 15 44.3284 15 43.5Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 29.5C15 28.6716 15.6716 28 16.5 28H29.5C30.3284 28 31 28.6716 31 29.5C31 30.3284 30.3284 31 29.5 31H16.5C15.6716 31 15 30.3284 15 29.5Z"
      className={`color-iconBrand  ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 36.5C15 35.6716 15.6716 35 16.5 35H29.5C30.3284 35 31 35.6716 31 36.5C31 37.3284 30.3284 38 29.5 38H16.5C15.6716 38 15 37.3284 15 36.5Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 29.5C35 28.6716 35.6716 28 36.5 28H39.5C40.3284 28 41 28.6716 41 29.5C41 30.3284 40.3284 31 39.5 31H36.5C35.6716 31 35 30.3284 35 29.5Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 36.5C35 35.6716 35.6716 35 36.5 35H37.5C38.3284 35 39 35.6716 39 36.5C39 37.3284 38.3284 38 37.5 38H36.5C35.6716 38 35 37.3284 35 36.5Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 61C51.5228 61 56 56.5228 56 51C56 45.4772 51.5228 41 46 41C40.4772 41 36 45.4772 36 51C36 56.5228 40.4772 61 46 61ZM46 64C53.1797 64 59 58.1797 59 51C59 43.8203 53.1797 38 46 38C38.8203 38 33 43.8203 33 51C33 58.1797 38.8203 64 46 64Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <circle
      cx="46"
      cy="51"
      r="10"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <g className="animate-spin origin-[46px_51px]">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.608 47.2705C44.3159 47.4063 43.2457 48.1823 42.6803 49.2548C42.4227 49.7433 41.8179 49.9306 41.3293 49.673C40.8408 49.4155 40.6535 48.8106 40.9111 48.3221C41.7745 46.6844 43.4154 45.4899 45.399 45.2815C47.3826 45.073 49.236 45.9002 50.421 47.3225C50.7745 47.7469 50.7171 48.3774 50.2927 48.7309C49.8684 49.0844 49.2379 49.027 48.8844 48.6027C48.1083 47.6712 46.9001 47.1347 45.608 47.2705ZM41.7073 53.269C42.1316 52.9155 42.7622 52.9729 43.1157 53.3972C43.8917 54.3287 45.0999 54.8652 46.392 54.7294C47.6841 54.5936 48.7543 53.8176 49.3197 52.7451C49.5773 52.2566 50.1821 52.0693 50.6707 52.3269C51.1592 52.5844 51.3465 53.1893 51.0889 53.6778C50.2256 55.3155 48.5847 56.51 46.6011 56.7185C44.6174 56.9269 42.764 56.0998 41.5791 54.6774C41.2256 54.253 41.283 53.6225 41.7073 53.269Z"
        className={`color-iconBrand ${pathClass}`}
      />
      <path
        d="M51.2296 49.5787L51.5824 47.0679C51.6444 46.6268 51.1422 46.3309 50.7864 46.599L47.9227 48.757C47.5669 49.025 47.7129 49.5894 48.154 49.6514L50.6648 50.0043C50.9383 50.0427 51.1911 49.8522 51.2296 49.5787Z"
        className={`color-iconBrand ${pathClass}`}
      />
      <path
        d="M40.7703 52.4194L40.4174 54.9303C40.3554 55.3714 40.8577 55.6673 41.2134 55.3992L44.0772 53.2412C44.4329 52.9731 44.287 52.4087 43.8459 52.3467L41.335 51.9939C41.0615 51.9554 40.8087 52.146 40.7703 52.4194Z"
        className={`color-iconBrand ${pathClass}`}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.0348 0.0986211C49.616 0.320405 50 0.877951 50 1.50006V40.3182H47V5.43117L45.5994 6.99929C45.3165 7.31599 44.9127 7.49795 44.488 7.50005C44.0634 7.50214 43.6578 7.32416 43.3718 7.01027L40.3809 3.72734L37.39 7.01027C37.1057 7.32226 36.7032 7.50006 36.2811 7.50006C35.8591 7.50006 35.4566 7.32226 35.1723 7.01027L32.1814 3.72734L29.1905 7.01027C28.9062 7.32226 28.5037 7.50006 28.0816 7.50006C27.6596 7.50006 27.257 7.32226 26.9728 7.01027L23.9819 3.72734L20.9909 7.01027C20.7067 7.32226 20.3042 7.50006 19.8821 7.50006C19.4601 7.50006 19.0575 7.32226 18.7733 7.01027L15.7824 3.72734L12.7914 7.01027C12.5089 7.32033 12.1095 7.49795 11.6901 7.50005C11.2706 7.50214 10.8695 7.32851 10.5839 7.02127L9 5.31717V54.683L10.5839 52.9789C10.8695 52.6716 11.2706 52.498 11.6901 52.5001C12.1095 52.5022 12.5089 52.6798 12.7914 52.9899L15.7824 56.2728L18.7733 52.9899C19.0575 52.6779 19.4601 52.5001 19.8821 52.5001C20.3042 52.5001 20.7067 52.6779 20.9909 52.9899L23.9819 56.2728L26.9728 52.9899C27.257 52.6779 27.6596 52.5001 28.0816 52.5001C28.5037 52.5001 28.9062 52.6779 29.1905 52.9899L32.2707 56.3709L34.2962 54.4914L36.3368 56.6905L33.2017 59.5996C32.9083 59.8718 32.5183 60.0155 32.1185 59.9987C31.7186 59.982 31.3421 59.8061 31.0726 59.5103L28.0816 56.2273L25.0907 59.5103C24.8065 59.8223 24.4039 60.0001 23.9819 60.0001C23.5598 60.0001 23.1573 59.8223 22.8731 59.5103L19.8821 56.2273L16.8912 59.5103C16.6069 59.8223 16.2044 60.0001 15.7824 60.0001C15.3603 60.0001 14.9578 59.8223 14.6735 59.5103L11.6716 56.2152L8.5987 59.5213C8.17886 59.973 7.52534 60.1217 6.95139 59.8961C6.37743 59.6706 6 59.1167 6 58.5001V1.50006C6 0.883381 6.37743 0.329536 6.95139 0.103989C7.52534 -0.121557 8.17886 0.0271592 8.5987 0.478858L11.6716 3.78491L14.6735 0.489862C14.9578 0.177871 15.3603 6.39127e-05 15.7824 6.39127e-05C16.2044 6.39127e-05 16.6069 0.177871 16.8912 0.489862L19.8821 3.77279L22.8731 0.489862C23.1573 0.177871 23.5598 6.39127e-05 23.9819 6.39127e-05C24.4039 6.39127e-05 24.8065 0.177871 25.0907 0.489862L28.0816 3.77279L31.0726 0.489862C31.3568 0.177871 31.7593 6.39127e-05 32.1814 6.39127e-05C32.6034 6.39127e-05 33.006 0.177871 33.2902 0.489862L36.2811 3.77279L39.2721 0.489862C39.5563 0.177871 39.9588 6.39127e-05 40.3809 6.39127e-05C40.803 6.39127e-05 41.2055 0.177871 41.4897 0.489862L44.4696 3.76068L47.3813 0.500834C47.7957 0.036853 48.4535 -0.123162 49.0348 0.0986211Z"
      className={`color-iconBrand ${pathClass}`}
    />
    <path
      d="M18.3027 14C19.6627 14 20.5889 14.7087 20.5889 16.1602C20.5888 16.8115 20.3026 17.3719 19.7998 17.6348C20.5541 17.9433 21 18.5717 21 19.5889C20.9999 21.1429 19.9943 21.9999 18.3604 22H15V14H18.3027ZM28 16H26.5V20H28V22H23V20H24.5V16H23V14H28V16ZM31.5 20H34.5V22H29.5V14H31.5V20ZM38 20H41V22H36V14H38V20ZM17 20.6289C17.9256 20.6289 18.9998 20.6286 19 19.5889C19 18.5003 17.9257 18.4805 17 18.4805V20.6289ZM17 17.1084C17.5943 17.1084 18.7499 17.1086 18.75 16.2744C18.75 15.3716 17.6286 15.3711 17 15.3711V17.1084Z"
      className={`color-iconBrand ${pathClass}`}
    />
  </svg>
)
